/** Normalised pilot-only cost-share hint (integer %, max 999). */
export function pilotMarkupPercentNumber(raw) {
  const n = Number(raw);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.min(999, Math.round(n));
}

/** e.g. "+12%" for pilots; null if none. */
export function formatPilotMarkupLabel(raw) {
  const p = pilotMarkupPercentNumber(raw);
  if (p <= 0) return null;
  return `+${p}%`;
}
